import { daysOfTheWeekS, generalHelpers, typesOfPreaching } from '@monorepo/helpers';
import { FC } from 'react';
import { Hr } from 'src/components/_commons';
import { typePublicMinistryMonthlyService } from '@monorepo/models';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    monthlyService: typePublicMinistryMonthlyService;
};

export const PublicMinistryByCalendar: FC<propsType> = ({ monthlyService }) => {
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    // const days = isMobile ? daysOfWeekMobileD : daysOfTheWeekP;

    const firstWeekdayOfMonth = new Date(monthlyService.year, monthlyService.month).getDay();
    const lastDayOfMonth = generalHelpers.GetDaysOfMonth(monthlyService.month, monthlyService.year);
    const servicesByDate = generalHelpers.GetPublicMinistryServicesByDay(monthlyService);
    let day = 1;

    return (
        <div>
            <div className={'calendar-header d-flex border-bottom'}>
                {/* <div className={'calendar-header-time flex-fill p-1'}></div> */}
                {[...daysOfTheWeekS.slice(1), daysOfTheWeekS[0]].map(wd => 
                    <div key={wd} className={'calendar-header-day flex-fill text-center fw-bold border-start'}>
                        {wd}
                    </div>
                )}
            </div>
            <div className={'small'}>
                {[1, 2, 3, 4, 5].map(h =>
                    <div key={h} className={'calendar-row d-flex align-items-start border py-1'}>
                        {[1, 2, 3, 4, 5, 6, 7].map(wd => {
                            const weekday = wd === 7 ? 0 : wd;
                            if (h > 1 || (weekday || 7) > firstWeekdayOfMonth) {
                                day += 1;
                            }
                            const services = servicesByDate.find(sd => sd.day === day)?.services ?? [];
                            return (
                                <div key={weekday}
                                    className={'flex-fill d-block border-end pointer custom-card'}
                                    style={{
                                        // alignItems: 'center',
                                        borderRadius: '5px',
                                        height: '240px',
                                        width: '100px'
                                    }}
                                    onClick={() => {}}
                                >
                                    {((h === 1 && ((weekday || 7) >= firstWeekdayOfMonth)) || (h > 1 && day <= lastDayOfMonth)) &&
                                        <>
                                        <div className={'text-center mt-2'}>
                                            {daysOfTheWeekS[weekday]} {day}
                                        </div>

                                        <Hr classes='mt-2' />

                                        {(services?.length ?? 0) > 4 ?
                                            <>
                                            {/* {services?.sort((s1, s2) => (s1.hour - s2.hour) || (s1.minutes || s2.minutes)).map(s => */}
                                            {[
                                                services!.sort((s1, s2) => (s1.hour - s2.hour) || (s1.minutes || s2.minutes))[0],
                                                services!.sort((s1, s2) => (s1.hour - s2.hour) || (s1.minutes || s2.minutes)).at(-1)]
                                            .map((s, i) =>
                                                <div key={s!.id} className={'ps-2'}>
                                                    <>
                                                    {!!i &&
                                                        <Hr />
                                                    }
                                                    {s!.hour.toString().padStart(2, '0')}:{s!.minutes.toString().padStart(2, '0')} hs.
                                                    &nbsp;{typesOfPreaching.find(tp => tp.type === s!.typeOfPreaching)?.label}
                                                    </>
                                                </div>
                                            )}
                                            </>
                                            :
                                            <>
                                            {services?.sort((s1, s2) => (s1.hour - s2.hour) || (s1.minutes || s2.minutes)).map((s, i) =>
                                                <div key={s.id} className={'ps-2'}>
                                                    <>
                                                    {!!i &&
                                                        <Hr />
                                                    }
                                                    {s.hour.toString().padStart(2, '0')}:{s.minutes.toString().padStart(2, '0')} hs.
                                                    &nbsp;{typesOfPreaching.find(tp => tp.type === s.typeOfPreaching)?.label}
                                                    {/* {!!s.groups.length &&
                                                        <>
                                                        <br />
                                                        {s.groups.length > 1 ?
                                                            `Grupos ${s.groups.slice(0, -1).join(', ')} y ${s.groups[s.groups.length - 1]}`
                                                            :
                                                            `Grupo ${s.groups[0]}`
                                                        }
                                                        </>
                                                    } */}
                                                    {/* <br />
                                                    {s.address1 ? s.address1 : ''} {s.address2 ? `o ${s.address2}` : ''} */}
                                                    </>
                                                </div>
                                            )}
                                            </>
                                        }
                                        </>
                                    }
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}
